import { $getSelection, $isRangeSelection } from 'lexical';
import { $setBlocksType } from '@lexical/selection';
import { Info, AlertTriangle, CheckCircle2 } from 'lucide-react';
import i18n from '../../i18n';
import { SlashOption } from '../ui/slashMenuOptions';
import { $createCalloutNode } from '../ui/lexicalNodes/CalloutNode';

const KINDS = [
  { kind: 'info', icon: Info, title: 'docEditor.callout.info', desc: 'docEditor.callout.infoDesc', keywords: ['callout', 'note', 'info', 'box'] },
  { kind: 'warning', icon: AlertTriangle, title: 'docEditor.callout.warning', desc: 'docEditor.callout.warningDesc', keywords: ['callout', 'warning', 'caution', 'alert'] },
  { kind: 'success', icon: CheckCircle2, title: 'docEditor.callout.success', desc: 'docEditor.callout.successDesc', keywords: ['callout', 'tip', 'success', 'done'] },
];

/**
 * The `/callout` slash-menu extras of the documents editor (card 2.5): one
 * option per kind, all matching "callout". Each turns the current block into
 * a callout, the way "/quote" turns it into a quote.
 *
 * Hosts must memoize the array (LexicalRichEditor's slashExtras note).
 */
export function buildCalloutSlashExtras() {
  return KINDS.map(
    ({ kind, icon, title, desc, keywords }) =>
      new SlashOption(i18n.t(title), {
        group: i18n.t('docEditor.callout.group'),
        description: i18n.t(desc),
        icon,
        keywords,
        onSelect: () => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) $setBlocksType(selection, () => $createCalloutNode(kind));
        },
      })
  );
}
